export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjk2ZWFjODY1LWZkY2ItNGI3NC05NWI3LWEwYmZkNWU4M2IyOCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.STK83YFDC0hRRmXfA3uLX5wxoOn8n+x1O1vcBRJffE6wjhfll32NSkPTw56TEZQLg1q9I5vcl5tbRaVRBarCZsAvJFG7meg0EjsnwF55egcWXdsqqGo6MUzsZTWZajZbCF8AaQ==";
